var render = function render(){var _vm=this,_c=_vm._self._c;return _c('content-page',{attrs:{"title":"Φιλοσοφία","icon":"mdi-basketball","loading":!_vm.philosophy}},[(_vm.philosophy)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.philosophy.content)}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }